module.exports = __webpack_public_path__ + "img/location_02@2x.9be9497a.png";